import React from 'react';
import styles from './Section.module.scss';
import cn from 'classnames';

const RowItem = (props) => (
  <div className={cn(styles.rowItem, props.className)}>{props.children}</div>
);

export default RowItem;
